<template>
  <div class="progress-bar-node">
    <div v-if="label" class="progress-bar-node__label">
      {{ label }}
    </div>
    <v-progress-linear
      :value="progress"
      :color="color"
      :height="height"
      :striped="striped"
      :indeterminate="indeterminate"
      rounded
    />
    <div v-if="showPercentage" class="progress-bar-node__percentage">
      {{ progress }}%
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ProgressBarNode',
  props: {
    nodeId: String,
    editMode: Boolean,
    progress: { type: Number, default: 0 },
    label: { type: String, default: '' },
    color: { type: String, default: 'primary' },
    height: { type: [Number, String], default: 8 },
    striped: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    showPercentage: { type: Boolean, default: true },
  },
};
</script>

<style lang="less">
.progress-bar-node {
  padding: 8px 0;

  &__label {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
    color: var(--v-darkGray-darken1);
  }

  &__percentage {
    font-size: 12px;
    color: var(--v-darkGray-base);
    margin-top: 4px;
    text-align: right;
  }
}
</style>
